<template>
  <div class="agent-fd">
    <div class="fd-header">
      <h2>返水明细</h2>
      <div class="date-filter">
        <input type="date" v-model="startDate" @change="handleQuery">
        <span class="date-separator">至</span>
        <input type="date" v-model="endDate" @change="handleQuery">
        <button class="filter-btn" @click="handleQuery">查询</button>
      </div>
    </div>

    <div class="fd-stats">
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalFd }}</div>
        <div class="stat-label">总返点</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ stats.totalValidBet }}</div>
        <div class="stat-label">总有效投注</div>
      </div>
      <div class="stat-item">
        <div class="stat-value">{{ formatRate(stats.avgFdRate) }}</div>
        <div class="stat-label">平均返点率</div>
      </div>
    </div>

    <div class="fd-content">
      <div class="list-title">返点明细</div>

      <div class="fd-table" v-if="fdRecords.length > 0">
        <div class="fd-table-header">
          <span class="col-date">时间</span>
          <span class="col-user">用户</span>
          <span class="col-game">平台</span>
          <span class="col-bet">有效投注</span>
          <span class="col-amount">返点金额</span>
          <span class="col-rate">返点率</span>
        </div>
        <div class="fd-table-row" v-for="fd in fdRecords" :key="fd.id">
          <span class="col-date">{{ fd.date }}</span>
          <span class="col-user">{{ fd.username }}</span>
          <span class="col-game">{{ fd.gameType }}</span>
          <span class="col-bet">{{ fd.validBet }}</span>
          <span class="col-amount highlight">{{ fd.amount }}</span>
          <span class="col-rate">{{ formatRate(fd.rate) }}</span>
        </div>
      </div>

      <div class="no-data" v-else>
        暂无返点记录
      </div>

      <div class="pagination" v-if="totalPages > 1">
        <button class="page-btn" @click="changePage(1)" :disabled="currentPage === 1">首页</button>
        <button class="page-btn" @click="changePage(currentPage - 1)" :disabled="currentPage === 1">上一页</button>
        <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页</span>
        <button class="page-btn" @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">下一页</button>
        <button class="page-btn" @click="changePage(totalPages)" :disabled="currentPage === totalPages">末页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agentFd',
  data() {
    return {
      startDate: '',
      endDate: '',
      stats: {
        totalFd: 0,
        totalValidBet: 0,
        avgFdRate: 0
      },
      fdRecords: [],
      currentPage: 1,
      totalPages: 1
    };
  },
  created() {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);
    this.startDate = sevenDaysAgo.toISOString().split('T')[0];
    this.endDate = today.toISOString().split('T')[0];

    this.getFdStats();
    this.getFdRecords();
  },
  methods: {
    formatRate(rate) {
      if (rate === null || rate === undefined || rate === '' || rate === '-') {
        return '0%';
      }
      const num = Number(rate);
      if (isNaN(num)) return '0%';
      return num + '%';
    },
    handleQuery() {
      this.currentPage = 1;
      this.getFdStats();
      this.getFdRecords();
    },
    getFdStats() {
      let that = this;
      let params = {
        start_date: this.startDate,
        end_date: this.endDate
      };
      this.$apiFun.get('/api/team/fdinfo', params).then(res => {
        if (res.code === 200) {
          that.stats = {
            totalFd: res.data.totalFd || 0,
            totalValidBet: res.data.totalValidBet || 0,
            avgFdRate: res.data.avgFdRate || 0
          };
        }
      }).catch(() => {
        that.stats = { totalFd: 0, totalValidBet: 0, avgFdRate: 0 };
      });
    },
    getFdRecords() {
      let that = this;
      let params = {
        page: this.currentPage,
        start_date: this.startDate,
        end_date: this.endDate
      };
      this.$apiFun.get('/api/team/fdList', params).then(res => {
        if (res.code === 200) {
          that.fdRecords = (res.data.data || []).map(item => ({
            ...item,
            rate: item.validBet > 0
              ? Math.round((item.amount / item.validBet) * 10000) / 100
              : (item.rate || 0)
          }));
          that.totalPages = res.data.totalPages || 1;
        } else {
          that.fdRecords = [];
          that.totalPages = 1;
        }
      }).catch(() => {
        that.fdRecords = [];
        that.totalPages = 1;
      });
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getFdRecords();
      }
    }
  }
};
</script>

<style scoped>
.agent-fd {
  padding: 15px;
  background: #f5f5f5;
  min-height: 100vh;
}

.fd-header {
  margin-bottom: 15px;
}

.fd-header h2 {
  margin: 0 0 12px;
  font-size: 18px;
  color: #333;
}

.date-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.date-filter input {
  flex: 1;
  min-width: 120px;
  padding: 8px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
}

.date-separator {
  color: #999;
  font-size: 14px;
}

.filter-btn {
  width: 100%;
  padding: 10px;
  background: #084ccb;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.fd-stats {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.stat-item {
  flex: 1;
  text-align: center;
  padding: 15px 8px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #084ccb;
  margin-bottom: 6px;
}

.stat-label {
  font-size: 12px;
  color: #888;
}

.fd-content {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.list-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.fd-table-header {
  display: grid;
  grid-template-columns: 1.2fr 0.9fr 0.7fr 0.9fr 0.9fr 0.7fr;
  gap: 6px;
  padding: 10px 8px;
  background: #f7f9fc;
  border-radius: 6px;
  font-size: 12px;
  color: #888;
  font-weight: 500;
}

.fd-table-row {
  display: grid;
  grid-template-columns: 1.2fr 0.9fr 0.7fr 0.9fr 0.9fr 0.7fr;
  gap: 6px;
  padding: 12px 8px;
  border-bottom: 1px solid #f5f5f5;
  font-size: 13px;
  color: #333;
  align-items: center;
}

.fd-table-row:last-child {
  border-bottom: none;
}

.fd-table-row:hover {
  background: #fafbfc;
}

.col-amount.highlight {
  color: #cf866b;
  font-weight: 600;
}

.col-rate {
  color: #084ccb;
  font-weight: 500;
}

.no-data {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

.page-btn {
  padding: 6px 12px;
  background: #f8f9fa;
  color: #333;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 13px;
  color: #666;
}

@media (max-width: 768px) {
  .fd-table-header {
    display: none;
  }

  .fd-table-row {
    display: block;
    padding: 12px;
    margin-bottom: 10px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    background: #fafbfc;
  }

  .fd-table-row span {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    font-size: 13px;
  }

  .fd-table-row span::before {
    color: #999;
    font-size: 12px;
  }

  .col-date::before { content: '时间'; }
  .col-user::before { content: '用户'; }
  .col-game::before { content: '平台'; }
  .col-bet::before { content: '有效投注'; }
  .col-amount::before { content: '返点金额'; }
  .col-rate::before { content: '返点率'; }
}
</style>



// WEBPACK FOOTER //
// src/components/agent/agentFd.vue